import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal, Col, Row, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
interface Modallsl {
  name: React.ReactNode;
  isopen: boolean;
  setisOpen: React.Dispatch<React.SetStateAction<boolean>>;
  form?: string;
  title: any;
  itemid: string | number | undefined;
  isSaving: boolean;
}
const Modalls = ({
  name,
  isopen,
  setisOpen,
  form,
  title,
  itemid,
  isSaving,
}: Modallsl) => {
  const [t] = useTranslation("common");
  const { itemid: urlId } = useParams();
  const isEdit = () => {
    return !!itemid;
  };
  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        onCancel={() => setisOpen(false)}
        open={isopen}
        centered
        footer={[
          <Button
            key="cancel-button"
            onClick={() => {
              setisOpen(false);
            }}
            style={{
              color: "#1677FF",
              border: "1px solid #1677FF",
              marginInlineEnd: "auto",
              height: "40px",
            }}
          >{`${t("cancel")}`}</Button>,
          <Button
            key="confirm-button"
            form={form}
            htmlType="submit"
            style={{
              background: "#1677FF",
              color: "#fff",
              height: "40px",
              border: "none",
            }}
            onClick={() => setisOpen(true)}
            disabled={isSaving}
          >
            {isSaving ? `${t("loading")}` : `${t("confirm")}`}
          </Button>,
        ]}
        title={
          <Row>
            <Col span={3}>
              <ExclamationCircleFilled
                style={{
                  color: "#FFBC39",
                  fontSize: "45px",
                  marginRight: "12px",
                  marginTop: "22px",
                }}
              />
            </Col>
            {isEdit() ? (
              <Col span={19}>
                <Col
                  style={{
                    fontSize: "32px",
                    color: "#212121",
                  }}
                >
                  {" "}
                  {t("Confirm Changes")}
                </Col>
                <Col
                  style={{
                    color: "#212121",
                    fontSize: "16px",
                  }}
                >
                  {t("please-confirm-saving-changes-to")}
                </Col>
                <Col
                  span={23}
                  style={{
                    fontSize: "15px",
                    color: "#212121",
                    wordWrap: "break-word",
                  }}
                >
                  {name}
                </Col>
              </Col>
            ) : (
              <Col
                span={19}
                style={{
                  fontSize: "32px",
                  color: "#212121",
                }}
              >
                {t("Confirm Adding")}
                <Col
                  span={24}
                  style={{
                    fontSize: "14px",
                    color: "#212121",
                  }}
                >
                  {t("please-confirm-adding")} {t("packaging-to-item")} {title}
                </Col>
              </Col>
            )}
          </Row>
        }
      />
    </>
  );
};
export default Modalls;
